import React from "react";

const AddMaterialNameModal = ({
  handleChange,
  setimgfile,
  handleAddDataSubmit,
  formRef,
  setRowAddData,
  rowAddData,
}) => {
  function resetFileds() {
    setRowAddData({
      unit: "",
      material_name: "",
    });
  }
  return (
    <div
      className="modal custom-modal fade"
      id="exampleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Add Material Name
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFileds}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Add Company</h4> */}
                  <form
                    className="form-sample"
                    ref={formRef}
                    onSubmit={handleAddDataSubmit}
                  >
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="material_Name">Material Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="material_name"
                            id="material_Name"
                            placeholder="Material Name"
                            onChange={handleChange}
                            value={rowAddData.material_name}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="unit">Unit</label>
                          <input
                            type="text"
                            className="form-control"
                            name="unit"
                            id="unit"
                            placeholder="Unit"
                            onChange={handleChange}
                            value={rowAddData.unit}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={handleAddDataSubmit}
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMaterialNameModal;
